import types from "../../../constants/action-types"

const defaultState = {
  saveds: [],
  favourites: [],
  vieweds: [],
  patterns: [],
  photo: "",
  token: localStorage.getItem("mmbs_access_token"),
  username: JSON.parse(localStorage.getItem("user"))?.name || "",
}

const map = {
  [types.SET_SAVEDS]: (state, { payload }) => ({
    ...state,
    saveds: payload.saveds,
    favourites: payload.selecteds,
    vieweds: payload.seens,
    photo: payload.photo,
  }),

  [types.GET_PATTERNS_ALL]: (state, { payload }) => {
    return {
      ...state,
      patterns: payload,
    }
  },
  [types.SET_TOKEN]: (state, { payload }) => ({
    ...state,
    token: payload,
  }),
  [types.SET_USERNAME]: (state, { payload }) => ({
    ...state,
    username: payload,
  }),

  [types.CLEAR_USERDATAS]: (state) => ({
    ...state,
    saveds: [],
    favourites: [],
    token: null,
    username: null,
    vieweds: [],
  }),
}

export default (state, action) =>
  (map[action.type] && map[action.type](state, action)) || state || defaultState
